<template>
    <div class="form">
      <div class="form-title">
        <h1>Contactame</h1>
      </div>
      <div class="form-wrapper">
        <div class="form-ilustration">
          <img src="../assets/image/pixeltrue-web-development.svg"/>
          <div class="form-text">
            <h3 class="form-text-h3">¿Quieres que crear algo nuevo?</h3>
            <p class="form-text-p">Escribeme!</p>
          </div>
        </div>
        <div class="form-contact">
            <section class="contact-section">
            <h2 class="contact-title">Escribeme</h2>
            <p class="contact-subtitle">¿Te gustaria que desarrollaramos algo?</p>

            <form class="contact-form" @submit.prevent="sendEmail">
              <div class="form-group">
                  <label for="name">Nombre</label>
                  <input v-model="form.name" type="text" id="name" required />
              </div>

              <div class="form-group">
                  <label for="email">Correo electrónico</label>
                  <input v-model="form.email" type="email" id="email" required />
              </div>

              <div class="form-group">
                  <label for="subject">Asunto</label>
                  <input v-model="form.subject" type="text" id="subject" required />
              </div>

              <div class="form-group">
                  <label for="message">Mensaje</label>
                  <textarea v-model="form.message" id="message" required></textarea>
              </div>

              <button type="submit" class="btn-submit">Enviar mensaje</button>
          </form>

            </section>
        </div>
    </div>
  </div>
</template>

<script>
import emailjs from "emailjs-com";

export default {
  name: "FormComponent",

  data() {
    return {
      form: {
        name: "",
        email: "",
        subject: "",
        message: ""
      }
    };
  },

  methods: {
    async sendEmail() {
      try {
        const params = {
          from_name: this.form.name,
          reply_to: this.form.email,
          subject: this.form.subject,
          message: this.form.message
        };
        //crear template y idServicio publico en emailjs 
        await emailjs.send(
          "service_v96gd6f",     // <-- reemplazar id servicio
          "template_ycqc2nd",    // <-- reemplaza id template
          params,
          "yvtmjJ3ABiuUKIYYU"      // <-- reemplaza
        );

        alert("Mensaje enviado correctamente");

        // limpiar formulario
        this.form = {
          name: "",
          email: "",
          subject: "",
          message: ""
        };

      } catch (error) {
        console.error(error);
        alert("Ocurrió un error al enviar el mensaje");
      }
    }
  }
};
</script>

<style>
.form{
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-height: 100vh;  
  padding: 20px;
  transform: scale(95%);
}

.form-title{
  color: var(--color-text);
}

.form-wrapper {
  display: flex;
  align-items: stretch;
  max-height: 721px;
}

.form-text{
  text-align: center;
}

.form-text-h3{
  color: white;
  font-size: 1.8rem;
  
}

.form-text-p{
  color: white;
}

.form-ilustration{
  display: flex;
  flex-direction: column;
  padding: 15% 0% 0% 0%;
  background-color: rgba(142, 81, 255, 0.675);
  border-radius: 20px 0px 0 20px;
}

.form-ilustration img{
  width: 500px;
  height: auto;
  padding: 0;
  display: block; /* elimina espacios fantasma */
}

.form-contact{
  background: rgba(20, 20, 30, 0.85);
  border: 0.5px solid #2a2a35;
  backdrop-filter: blur(5px);
  border-radius: 0px 60px 60px 0px;
  padding: 0px 50px;
  max-width: 500px;
  width: 90%;
  box-shadow: 0 0 20px rgba(140, 90, 255, 0.2);
  margin: 0%;
}

.contact-section {
  max-width: 600px;
  margin: 60px auto;
  padding: 20px;
  text-align: center;
  color: white;
}

.contact-title {
  font-size: 2rem;
  margin-bottom: 10px;
  color: #b693ff;
}

.contact-subtitle {
  margin-bottom: 30px;
  color: #bbb;
}

.contact-form {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.form-group {
  text-align: left;
}

.form-group label {
  display: block;
  margin-bottom: 6px;
  font-weight: 600;
  color: #ddd;
}

.form-group input,
.form-group textarea {
  width: 100%;
  background: #121218;
  border: 1px solid #2a2a35;
  border-radius: 10px;
  padding: 12px;
  font-size: 0.95rem;
  color: white;
  outline: none;
  transition: 0.3s;
}

.form-group input:focus,
.form-group textarea:focus {
  border-color: #b693ff;
  background: #161622;
}

.btn-submit {
  margin-top: 10px;
  padding: 14px;
  background: #b693ff;
  color: #0f0f14;
  border: none;
  border-radius: 12px;
  font-size: 1rem;
  font-weight: bold;
  cursor: pointer;
  transition: 0.3s;
}

.btn-submit:hover {
  background: #c6a8ff;
  transform: translateY(-2px);
}

@media (max-width: 768px) {
  .form{
    /*EDITAR DESPUES PARA QUE SEA MAS RESPONSIVO */
    scale: 0.6;
    padding-bottom: 50%;
  }

  .form-wrapper {
    display: grid;
  }

  .form-contact{
    border-radius: 0%;
    border-radius: 0 0 20px 20px;
  }

  .form-ilustration{
    display: block;
    border-radius: 0%;
    width: 600px;
    padding: 0%;
    border-radius: 20px 20px 0 0;
  }

  .form-ilustration img{
    justify-self: center;
    width: 200px;
    height: auto;
  }

}
</style>